export const PERA_WALLET_PARTNER_NAME = 'pera wallet';

export interface ZendeskLinkContext {
  cardholderId: string;
  errorReason: string;
}

interface PartnerZenDeskConfig {
  partnerName: string;
  create: (ctx: ZendeskLinkContext) => URL;
}

export class PeraZenDeskConfig implements PartnerZenDeskConfig {
  partnerName = PERA_WALLET_PARTNER_NAME;

  create(ctx: ZendeskLinkContext) {
    // See: https://support.zendesk.com/hc/en-us/articles/4408839114522-Creating-pre-filled-ticket-forms
    const baseUrl = new URL('https://peracard.zendesk.com/hc/en-us/requests/new');
    baseUrl.searchParams.append('ticket_form_id', '43860858529817');
    baseUrl.searchParams.append('tf_43860884225561', ctx.cardholderId);
    baseUrl.searchParams.append('tf_44699296079257', ctx.errorReason);

    return baseUrl;
  }
}

export const partnerConfigs: Map<string, PartnerZenDeskConfig> = new Map([
  [PERA_WALLET_PARTNER_NAME, new PeraZenDeskConfig()],
]);

export class ZendeskPartnerSupportLink {
  partnerConfig: PartnerZenDeskConfig;

  constructor(partnerConfig: PartnerZenDeskConfig) {
    this.partnerConfig = partnerConfig;
  }

  create(ctx: ZendeskLinkContext) {
    return this.partnerConfig.create(ctx);
  }

  static forPartnerName(partnerName: string) {
    const partnerConfig = partnerConfigs.get(partnerName);
    if (!partnerConfig) {
      throw new Error(`No Zendesk config found for partner: ${partnerName}`);
    }
    return new ZendeskPartnerSupportLink(partnerConfig);
  }
}
